<script>
  // The in-binder Want List STAR (ADR-0009) — the single want indicator, wholly
  // separate from the per-binder selection basket and trade selection. Extracted
  // out of the shared CardSlot (review §5) so CardSlot no longer owns the want
  // store, auth/OAuth, or the toggle handler: it just renders <WantStar card=…/>.
  //
  // Filled when the card is on the viewer's Want List: the viewer's want hits
  // for the binder on screen (want-hits store), unless a tap's optimistic
  // override says otherwise. An anonymous visitor sees the star but is sent to
  // Discord login on tap.
  import { isCardWanted, toggleWant } from '../../lib/stores/wantlist.svelte.js';
  import { isUserAnonymous, initiateDiscordOAuth } from '../../lib/stores/auth.svelte.js';
  import { binderState } from '../../lib/stores/binder.svelte.js';

  let { card = null, cardName = '' } = $props();

  const isWanted = $derived(isCardWanted(card, binderState.binderUrl));

  async function handleClick(e) {
    e.stopPropagation();
    e.preventDefault();
    if (!card) return;
    if (isUserAnonymous()) {
      initiateDiscordOAuth();
      return;
    }
    await toggleWant(card, isWanted);
  }
</script>

<button
  type="button"
  class="want-star"
  class:filled={isWanted}
  title={isWanted ? `Remove ${cardName} from your want list` : `Add ${cardName} to your want list`}
  aria-label={isWanted
    ? `Remove ${cardName} from your want list`
    : `Add ${cardName} to your want list`}
  aria-pressed={isWanted}
  onclick={handleClick}
>
  {isWanted ? '★' : '☆'}
</button>

<style>
  /* Want List STAR — the single in-binder want indicator (ADR-0009), replacing
     the old purple want-list outline. Functional placeholder styling;
     final visual treatment + mobile gesture are a deferred web-designer task. */
  .want-star {
    position: absolute;
    top: 4px;
    left: 4px;
    z-index: var(--z-card-selection, 7);
    width: 28px;
    height: 28px;
    padding: 0;
    border: none;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.45);
    color: rgba(255, 255, 255, 0.8);
    font-size: 18px;
    line-height: 28px;
    text-align: center;
    cursor: pointer;
    opacity: 0;
    transition:
      opacity 0.15s ease,
      transform 0.1s ease;
  }

  /* Revealed on hover of the host card slot, when filled, or on focus. The
     :global hook lets the parent .card-slot:hover toggle this child. */
  :global(.card-slot:hover) .want-star,
  .want-star.filled,
  .want-star:focus-visible {
    opacity: 1;
  }

  .want-star.filled {
    color: #fbbf24;
  }

  .want-star:active {
    transform: scale(0.9);
  }
</style>
